module.exports = __webpack_public_path__ + "static/media/planet-background_o.2f0a565e.jpg";